module.exports = __webpack_public_path__ + "static/media/PM34.71f60e40.png";